import React from 'react';
import { Users, DollarSign, Star } from 'lucide-react';

const stats = [
  {
    value: "20,000+",
    label: "Happy Clients",
    color: "text-cyan-400"
  },
  {
    value: "$50M+",
    label: "Client Revenue Generated",
    color: "text-green-400"
  },
  {
    value: "4.9/5",
    label: "Average Rating",
    color: "text-emerald-400"
  }
];

const TrustStats = () => {
  return (
    <section className="py-10 bg-slate-950">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-slate-900/80 border border-slate-800 rounded-2xl p-8">
          <div className="grid grid-cols-3 divide-x divide-slate-700">
            {stats.map((stat, index) => (
              <div key={index} className="text-center px-2 sm:px-4">
                <p className={`text-xl sm:text-3xl md:text-4xl lg:text-5xl font-bold ${stat.color} mb-1 sm:mb-2`}>
                  {stat.value}
                </p>
                <p className="text-slate-400 text-xs sm:text-sm md:text-base">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustStats;
